<template>
  <client-only>
    <Head>
      <Title>
        {{ $t("bnpl:pageTitle.default") }}
      </Title>
    </Head>

    <PrescoreWelcome />
  </client-only>
</template>

<script setup>
import { useSessionStore } from "~/stores/session";

const sessionStore = useSessionStore();

definePageMeta({
  layout: "prescore",
});

onBeforeMount(() => {
  navigateTo({ name: "financier-prescore", replace: true });
});
</script>
